import { List } from 'immutable'

const Colors = {}

const _random = (min, max) => Math.random() * (max - min + 1) + min

export const rgbToHex = rgb => {
  let hex = '#'
  const r = Math.floor(rgb[0]).toString(16)
  hex += 1 == r.length ? '0' + r : r
  const g = Math.floor(rgb[1]).toString(16)
  hex += 1 == g.length ? '0' + g : g
  const b = Math.floor(rgb[2]).toString(16)
  hex += 1 == b.length ? '0' + b : b
  return hex
}
export const hexToRgb = hex => {
  const _hex = hex.replace(/#/, '')

  if (3 == _hex.length) {
    return [
      parseInt(_hex.slice(0, 1) + _hex.slice(1, 2), 16),
      parseInt(_hex.slice(1, 2) + _hex.slice(2, 3), 16),
      parseInt(_hex.slice(2, 3) + _hex.slice(0, 1), 16)
    ]
  } else if (6 == _hex.length) {
    return [parseInt(_hex.slice(0, 2), 16), parseInt(_hex.slice(2, 4), 16), parseInt(_hex.slice(4, 6), 16)]
  } else {
    return [0, 0, 0]
  }
}
Colors.rgbToHex = rgbToHex
Colors.hexToRgb = hexToRgb

export const rgbToHsl = (r, g, b) => {
  const max = Math.max(r, g, b) / 255
  const min = Math.min(r, g, b) / 255

  let h = 0
  let s = 0
  const l = (max + min) / 2

  if (max != min) {
    const d = max - min

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    if (max == r / 255 && g >= b) {
      h = (1.0472 * (g - b)) / 255 / d
    } else if (max == r / 255 && g < b) {
      h = (1.0472 * (g - b)) / 255 / d + 6.2832
    } else if (max == g / 255) {
      h = (1.0472 * (b - r)) / 255 / d + 2.0944
    } else if (max == b / 255) {
      h = (1.0472 * (r - g)) / 255 / d + 4.1888
    }

    h = h / 6.2832
  }

  return [360 * h, 100 * s, 100 * l]
}
export const hslToRgb = (h, s, l) => {
  let r = l / 100
  let g = l / 100
  let b = l / 100

  if (0 != s) {
    const hue2rgb = (p, q, t) => {
      let _t = t
      if (_t < 0) _t += 1
      if (_t > 1) _t -= 1
      if (_t < 1 / 6) return p + (q - p) * 6 * _t
      if (_t < 1 / 2) return q
      if (_t < 2 / 3) return p + (q - p) * (2 / 3 - _t) * 6
      return p
    }

    const q = l / 100 < 0.5 ? (l * (1 + s / 100)) / 100 : (l + s) / 100 - (l * s) / 10000
    const p = (2 * l) / 100 - q

    r = hue2rgb(p, q, h / 360 + 1 / 3)
    g = hue2rgb(p, q, h / 360)
    b = hue2rgb(p, q, h / 360 - 1 / 3)
  }
  return [255 * r, 255 * g, 255 * b]
}
Colors.rgbToHsl = rgbToHsl
Colors.hslToRgb = hslToRgb

export const hexToHsl = hex => {
  const rgb = hexToRgb(hex)
  return rgbToHsl(rgb[0], rgb[1], rgb[2])
}
export const hslToHex = hsl => rgbToHex(hslToRgb(hsl[0], hsl[1], hsl[2]))
Colors.hexToHsl = hexToHsl
Colors.hslToHex = hslToHex

export const hexToRgba = (hex, a) => {
  const _a = 'undefined' == typeof a || null === a ? 1 : Math.max(Math.min(a, 1), 0)
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5), 16)
  return `rgba(${r}, ${g}, ${b}, ${_a})`
}
Colors.hexToRgba = hexToRgba

export const colorsBlend = (c1, c2, pr) => {
  const r1 = Number('0x' + c1[1] + c1[2])
  const r2 = Number('0x' + c2[1] + c2[2])
  const g1 = Number('0x' + c1[3] + c1[4])
  const g2 = Number('0x' + c2[3] + c2[4])
  const b1 = Number('0x' + c1[5] + c1[6])
  const b2 = Number('0x' + c2[5] + c2[6])

  const r = parseInt(r1 - (r1 - r2) * pr, 10)
  const g = parseInt(g1 - (g1 - g2) * pr, 10)
  const b = parseInt(b1 - (b1 - b2) * pr, 10)

  return rgbToHex([r, g, b])
}
Colors.colorsBlend = colorsBlend

export const calcGradientColors = (colorStart, colorEnd, colorCount) => {
  const l = colorCount - 1
  const start = hexToRgb(colorStart)
  const end = hexToRgb(colorEnd)

  const saida = []
  for (let i = 0; i <= l; i++) {
    const c = [
      (i * end[0]) / l + (1 - i / l) * start[0],
      (i * end[1]) / l + (1 - i / l) * start[1],
      (i * end[2]) / l + (1 - i / l) * start[2]
    ]
    saida.push(rgbToHex(c))
  }
  return saida
}
Colors.calcGradientColors = calcGradientColors

export const colorsGradients = (colorStart, colorEnd, colorCount) => {
  const l = colorCount - 1
  const start = hexToRgb(colorStart)
  const end = hexToRgb(colorEnd)

  const saida = []
  for (let i = 0; i <= l; i++) {
    const c = [
      (i * end[0]) / l + (1 - i / l) * start[0],
      (i * end[1]) / l + (1 - i / l) * start[1],
      (i * end[2]) / l + (1 - i / l) * start[2]
    ]
    saida.push(rgbToHex(c))
  }
  return saida
}
Colors.colorsGradients = colorsGradients

export const transformHex = (hex, matrix) => {
  if (!hex) return null

  const hsl = hexToHsl(hex)

  return hslToHex([hsl[0] + matrix[0], hsl[1] + matrix[1], hsl[2] + matrix[2]])
}
Colors.transformHex = transformHex

export const randomHex = (hex, d = 1, type = 'random') => {
  if (null !== hex) {
    const hsl = hexToHsl(hex)

    const matrix = [_random(-5, 5), _random(hsl[1] / d, (hsl[1] - 100) / d), _random(hsl[2] / d, (hsl[2] - 100) / d)]

    return hslToHex([hsl[0] + matrix[0], hsl[1] - matrix[1], hsl[2] - matrix[2]])
  }

  let sMin = 10
  let sMax = 90
  let lMin = 10
  let lMax = 90

  switch (type) {
    case 'bright': {
      sMin = 55
      break
    }
    case 'light': {
      sMax = 55
      lMin = (lMax + lMin) / 2
      break
    }
    case 'dark': {
      sMin = sMax - 30
      lMax = lMin + 30
      break
    }
    default: {
      sMin = 20
      sMax = 80
      lMin = 25
      lMax = 75
      break
    }
  }

  return hslToHex([_random(0, 360), _random(sMin, sMax), _random(lMin, lMax)])
}
Colors.randomHex = randomHex

const harmonizedParams = {
  complementary: { start: 180, end: 180, step: 1 },
  split_complementary: { start: 150, end: 210, step: 60 },
  triadic: { start: 120, end: 240, step: 120 },
  tetradic: { start: 90, end: 270, step: 90 },
  analogous: { start: 30, end: 90, step: 30 },
  analogous_hue: { start: 7, end: 35, step: 7 },
  analogous_random: { start: 30, end: 90, step: 30 }
}

const RANDOM_METHODS = [
  'complementary',
  'split_complementary',
  'triadic',
  'tetradic',
  'analogous_hue',
  'analogous_random'
]
const RANDOM_METHODS_D = [1.4, 1.4, 1.6, 1.6, 10, 2]

export const harmonized = (hex, method, reverse = false) => {
  if (!hex) return []

  const hsl = hexToHsl(hex)
  const { start, end, step } = harmonizedParams[method]

  let colors = new List([])
  const index = RANDOM_METHODS.indexOf(method)
  for (let i = start; i <= end; i += step) {
    const color = hslToHex([(hsl[0] + (reverse ? -1 : 1) * i + 360) % 360, hsl[1], hsl[2]])
    colors = colors.push(-1 < index ? randomHex(color, RANDOM_METHODS_D[index]) : color)
  }
  return colors
}
Colors.harmonized = harmonized

export const complementary = (hex, reverse = false) => {
  const r = Math.floor(3 * Math.random()) + 1
  let colors = new List([hex])
  while (r > colors.size) {
    const color = colors.get(colors.size - 1)
    colors = colors.push(randomHex(color, 1.3))
  }
  return new List([...colors.shift(), ...harmonized(colors.get(colors.size - 1), 'complementary', reverse)])
}
Colors.complementary = complementary

export const monochromatic = (hex, d = 1, reverse = false) => {
  if (!hex) return null

  const hsl = hexToHsl(hex)
  const matrix = [
    _random(-5, 5),
    0,
    reverse ? _random((hsl[2] - 100) / d, (hsl[2] - 100) / (2 * d)) : _random(hsl[2] / (2 * d), hsl[2] / d)
  ]

  return hslToHex([(hsl[0] - matrix[0] + 360) % 360, hsl[1], Math.max(0, hsl[2] - matrix[2])])
}
Colors.monochromatic = monochromatic

const randomTypes = ['bright', 'light', 'dark', 'random']

export const calculate = (hex, method, total, reverse = false) => {
  let colors = new List('random' == method ? [] : [hex])
  const randomTypesIndex = 'random' == method ? Math.floor(randomTypes.length * Math.random()) : -1
  while (total > colors.size) {
    if ('random' == method) {
      colors = colors.push(randomHex(null, null, randomTypes[randomTypesIndex]))
    } else {
      const color = colors.get(colors.size - 1)
      switch (method) {
        case 'monochromatic':
          colors = colors.push(monochromatic(color, 1.7 * total - colors.size, reverse))
          break
        case 'complementary':
          colors = new List([...colors, ...complementary(color, reverse)])
          break
        default:
          colors = new List([...colors, ...harmonized(color, method, reverse)])
          break
      }
    }
  }
  return colors.splice(total)
}
Colors.calculate = calculate

export default Colors
